 

// import Select from 'react-select';
// import { useEffect, useMemo, useState } from 'react';
// import { useTranslation } from 'react-i18next';
// import Loading from '@components/Shared/Loader/Loading';
// import { Card, CardFooter, CardHeader } from '@components/card/card';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { initReport, getReportPagedData, selectReport, setReportRequest } from '@store/DynamicSlice/reportTableSlice';
// import ReportExportExcelModal, { type ExportColumn } from '@Helper/ReportPaged/ReportExportExcelModal';
// import ReportPagination from '@Helper/ReportPaged/ReportPagination';
// import useGlChartLookups from '@hooks/Finance/ChartAccountsDetails/useGlChartLookups';

// /** =========================
//  *  NEW REQUEST SHAPE
//  *  {
//  *    request: {
//  *      froM_DATE, tO_DATE, froM_BRANCH, tO_BRANCH, doC_ID,
//  *      pageIndex, pageSize,
//  *      fromDate, toDate, fromBranch, toBranch, docId,
//  *    }
//  *  }
//  *  ========================= */
// type BranchTransferInnerRequestDto = {
//   pageIndex?: number;
//   pageSize?: number;

//   // Dates (dual naming)
//   froM_DATE?: string | null;
//   tO_DATE?: string | null;
//   fromDate?: string | null;
//   toDate?: string | null;

//   // Branches (dual naming)
//   froM_BRANCH?: string | null;
//   tO_BRANCH?: string | null;
//   fromBranch?: string | null;
//   toBranch?: string | null;

//   // Doc (dual naming)
//   doC_ID?: string | null;
//   docId?: string | null;

//   // Optional
// };

// type ReportRequestDto = {
//   request: BranchTransferInnerRequestDto;
// };

// /** =========================
//  *  NEW RESPONSE SHAPE (Array items)
//  *  ========================= */
// type RowDto = {
//   gL_DATE: string;
//   code: string;

//   jE_SOURCE?: string | null;
//   jE_CATEGORY?: string | null;

//   description?: string | null;

//   doC_ID?: string | null;

//   froM_BRANCH?: string | null;
//   froM_BRANCH_NAME?: string | null;
//   froM_BRANCH_NAME2?: string | null;

//   tO_BRANCH?: string | null;
//   tO_BRANCH_NAME?: string | null;
//   tO_BRANCH_NAME2?: string | null;

//   amount?: number | null;

//   alloC_PCT?: number | null;
//   tO_NET_DEBIT?: number | null;
//   froM_CREDIT_ABS?: number | null;
//   totaL_CREDIT_ABS?: number | null;

//   jE_HEADER_ID?: string | null;
//   method?: string | null; // EXPLICIT | INFERRED
// };

// const REPORT_KEY = 'RPT_BranchTransfers';
// const ENDPOINT = 'Finance/GetBranchTransferPaged';

// const safe = (v: any, fallback = '—') => (v === null || v === undefined || v === '' ? fallback : String(v));
// const n0 = (v: any) => (v === null || v === undefined || Number.isNaN(Number(v)) ? 0 : Number(v));

// const formatNumber = (num: number, digits: number = 2) => {
//   return new Intl.NumberFormat('en-US', {
//     minimumFractionDigits: digits,
//     maximumFractionDigits: digits
//   }).format(num);
// };

// const formatDate = (dateString: string) => {
//   if (!dateString) return '—';
//   const date = new Date(dateString);
//   return new Intl.DateTimeFormat('en-US', {
//     year: 'numeric',
//     month: '2-digit',
//     day: '2-digit'
//   }).format(date);
// };

// const getOptId = (opt: any): string | null => {
//   const v = opt?.value ?? opt?.id ?? opt?.ID ?? opt?.key ?? null;
//   return v ? String(v) : null;
// };

// const isoOrNull = (d: Date | null) => (d ? d.toISOString() : null);

// const cleanNulls = <T extends Record<string, any>>(obj: T): Partial<T> => {
//   const out: any = {};
//   for (const [k, v] of Object.entries(obj)) {
//     if (v === null || v === undefined || v === '') continue;
//     out[k] = v;
//   }
//   return out;
// };

// // Heuristic for EXPLICIT rows (when debit/credit fields are null)
// const guessDirection = (r: RowDto) => {
//   const d = (r.description || '').toString();
//   const isReceipt = /استلام|receipt/i.test(d);
//   const isIssue = /صرف|issue/i.test(d);
//   if (isReceipt && !isIssue) return 'IN';
//   if (isIssue && !isReceipt) return 'OUT';
//   return null;
// };

// const amountOf = (r: RowDto) => n0(r.amount);

// const debitOf = (r: RowDto) => {
//   if (r.tO_NET_DEBIT !== null && r.tO_NET_DEBIT !== undefined) return n0(r.tO_NET_DEBIT);
//   const dir = guessDirection(r);
//   if (dir === 'IN') return amountOf(r);
//   return 0;
// };

// const creditOf = (r: RowDto) => {
//   if (r.froM_CREDIT_ABS !== null && r.froM_CREDIT_ABS !== undefined) return n0(r.froM_CREDIT_ABS);
//   if (r.totaL_CREDIT_ABS !== null && r.totaL_CREDIT_ABS !== undefined) return n0(r.totaL_CREDIT_ABS);
//   const dir = guessDirection(r);
//   if (dir === 'OUT') return amountOf(r);
//   return 0;
// };

// const BranchTransfers_Paged = () => {
//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();

//   // options

//   const { OptionsBranches, loading: loading2, error: error2 } = useGlChartLookups();

//   // Filters state
//   const [branchFromFilter, setBranchFromFilter] = useState<any>(null);
//   const [branchToFilter, setBranchToFilter] = useState<any>(null);

//   // Date range
//   const [fromDate, setFromDate] = useState<any>(null);
//   const [toDate, setToDate] = useState<any>(null);

//   const [showExport, setShowExport] = useState(false);

//   // report state
//   const report = useAppSelector(s => selectReport(s as any, REPORT_KEY));
//   const items = (report?.items ?? []) as RowDto[];
//   const meta = report?.meta ?? null;
//   const loading = report?.loading ?? false;
//   const error = report?.error ?? null;
//   const isAr = i18n.language !== 'en';

//   const activeFiltersCount = useMemo(() => {
//     let c = 0;
//     if (branchFromFilter) c++;
//     if (branchToFilter) c++;
//     if (fromDate) c++;
//     if (toDate) c++;
//     return c;
//   }, [branchFromFilter, branchToFilter, fromDate, toDate]);

//   const exportColumns: ExportColumn<RowDto>[] = [
//     { headerAr: 'تاريخ القيد', headerEn: 'GL Date', value: r => formatDate(r.gL_DATE) },
//     { headerAr: 'رقم القيد', headerEn: 'JE Code', value: r => r.code || '' },
//     { headerAr: 'من فرع', headerEn: 'From Branch', value: r => r.froM_BRANCH_NAME || '' },
//     { headerAr: 'إلى فرع', headerEn: 'To Branch', value: r => r.tO_BRANCH_NAME || '' },
//     { headerAr: 'مدين', headerEn: 'Debit', value: r => debitOf(r) },
//     { headerAr: 'دائن', headerEn: 'Credit', value: r => creditOf(r) },
//     { headerAr: 'المبلغ', headerEn: 'Amount', value: r => amountOf(r) },
//     { headerAr: 'الطريقة', headerEn: 'Method', value: r => r.method || '' },
//     { headerAr: 'الوصف', headerEn: 'Description', value: r => r.description || '' },
//     { headerAr: 'معرف المستند', headerEn: 'Doc ID', value: r => r.doC_ID || '' }
//   ];

//   useEffect(() => {
//     const initialRequest: ReportRequestDto = {
//       request: {
//         pageIndex: 0,
//         pageSize: 50
//       }
//     };

//     dispatch(
//       initReport({
//         reportKey: REPORT_KEY,
//         endpoint: ENDPOINT,
//         initialRequest
//       })
//     );

//     dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
//   }, [dispatch]);

//   const applyFilters = () => {
//     const fromBranchId = getOptId(branchFromFilter);
//     const toBranchId = getOptId(branchToFilter);

//     const prevOuter = (((report as any)?.request ?? {}) as ReportRequestDto) || { request: {} as any };
//     const prevInner = (prevOuter?.request ?? {}) as BranchTransferInnerRequestDto;

//     const nextInner: BranchTransferInnerRequestDto = {
//       ...prevInner,
//       pageIndex: 0,
//       pageSize: prevInner.pageSize ?? 50,

//       // Dates (dual naming)
//       froM_DATE: isoOrNull(fromDate),
//       tO_DATE: isoOrNull(toDate),
//       fromDate: isoOrNull(fromDate),
//       toDate: isoOrNull(toDate),

//       // Branches (dual naming)
//       froM_BRANCH: fromBranchId,
//       tO_BRANCH: toBranchId,
//     //   fromBranch: fromBranchId,
//     //   toBranch: toBranchId
//     };

//     const nextOuter: ReportRequestDto = {
//       ...prevOuter,
//       request: cleanNulls(nextInner) as BranchTransferInnerRequestDto
//     };

//     dispatch(setReportRequest({ reportKey: REPORT_KEY, request: nextOuter as any }));
//     dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
//   };

//   const clearFilters = () => {
//     setBranchFromFilter(null);
//     setBranchToFilter(null);
//     setFromDate(null);
//     setToDate(null);

//     const nextOuter: ReportRequestDto = {
//       request: {
//         pageIndex: 0,
//         pageSize: 50
//       }
//     };

//     dispatch(setReportRequest({ reportKey: REPORT_KEY, request: nextOuter as any }));
//     dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
//   };

//   // Totals
//   const totals = useMemo(() => {
//     return items.reduce(
//       (acc, row) => {
//         const a = amountOf(row);
//         const dr = debitOf(row);
//         const cr = creditOf(row);

//         acc.totalAmount += a;
//         acc.totalDebit += dr;
//         acc.totalCredit += cr;

//         // Outgoing/Incoming (based on DR/CR heuristics)
//         const fromId = row.froM_BRANCH || '';
//         const toId = row.tO_BRANCH || '';
//         if (fromId && toId && fromId !== toId) {
//           if (cr > 0) acc.totalOutgoing += cr;
//           if (dr > 0) acc.totalIncoming += dr;
//         }

//         if ((row.method || '').toUpperCase() === 'EXPLICIT') acc.totalExplicit += a;
//         if ((row.method || '').toUpperCase() === 'INFERRED') acc.totalInferred += a;

//         return acc;
//       },
//       {
//         totalAmount: 0,
//         totalDebit: 0,
//         totalCredit: 0,
//         totalOutgoing: 0,
//         totalIncoming: 0,
//         totalExplicit: 0,
//         totalInferred: 0
//       }
//     );
//   }, [items]);

//   return (
//     <>
//       <CardHeader className='mb-3'>
//         <div className='row g-2 align-items-center'>
//           {/* من فرع */}
//           <div className='col-lg-3'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-sign-out-alt text-danger'></i>
//               </span>
//               <Select
//                 isLoading={loading2}
//                 value={branchFromFilter}
//                 onChange={setBranchFromFilter}
//                 options={OptionsBranches}
//                 placeholder={isAr ? 'من فرع' : 'From Branch'}
//                 isClearable
//                 isSearchable
//                 className='flex-grow-1'
//                 classNamePrefix='react-select'
//                 menuPortalTarget={document.body}
//                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//               />
//             </div>
//           </div>

//           {/* إلى فرع */}
//           <div className='col-lg-3'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-sign-in-alt text-success'></i>
//               </span>
//               <Select
//                 isLoading={loading2}
//                 value={branchToFilter}
//                 onChange={setBranchToFilter}
//                 options={OptionsBranches}
//                 placeholder={isAr ? 'إلى فرع' : 'To Branch'}
//                 isClearable
//                 isSearchable
//                 className='flex-grow-1'
//                 classNamePrefix='react-select'
//                 menuPortalTarget={document.body}
//                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//               />
//             </div>
//           </div>

//           {/* من تاريخ */}
//           <div className='col-lg-2'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-calendar'></i>
//               </span>
//               <input
//                 type='date'
//                 className='form-control'
//                 value={fromDate}
//                 onChange={e => setFromDate(e.target.value)}
//                 placeholder={isAr ? 'من تاريخ' : 'From Date'}
//               />
//             </div>
//           </div>

//           {/* إلى تاريخ */}
//           <div className='col-lg-2'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-calendar'></i>
//               </span>
//               <input
//                 type='date'
//                 className='form-control'
//                 value={toDate}
//                 onChange={e => setToDate(e.target.value)}
//                 min={fromDate}
//                 placeholder={isAr ? 'إلى تاريخ' : 'To Date'}
//               />
//             </div>
//           </div>

//           {/* Buttons */}
//           <div className='col-lg-2 text-end'>
//             <button
//               className='btn btn-outline-secondary me-2'
//               type='button'
//               onClick={clearFilters}
//               title={t('ClearFilters')}
//               disabled={activeFiltersCount === 0}
//             >
//               <i className='fas fa-times fa-fw'></i>
//             </button>
//             <button
//               className='btn btn-theme me-2'
//               type='button'
//               onClick={applyFilters}
//               title={t('ApplyFilters')}
//               disabled={activeFiltersCount === 0}
//             >
//               <i className='fas fa-filter fa-fw'></i>
//             </button>

//             <button
//               className='btn btn-outline-success'
//               type='button'
//               onClick={() => setShowExport(true)}
//               title={t('Export')}
//               disabled={loading}
//             >
//               <i className='fas fa-file-excel fa-fw'></i>
//             </button>
//           </div>
//         </div>
//       </CardHeader>

//       <Card className='mb-4'>
//         <Loading loading={loading} error={error}>
//           <div className='table-responsive' style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
//             <table className='table table-hover mb-0'>
//               <thead className='sticky-top' style={{ top: 0, zIndex: 10 }}>
//                 <tr className='bg-theme bg-opacity-35' style={{ backdropFilter: 'blur(20px)' }}>
//                   <th className='small ' style={{ minWidth: '110px' }}>
//                     <div className='d-flex align-items-center'>
//                       <i className='fas fa-calendar-alt me-2'></i>
//                       <span>{t('Date')}</span>
//                     </div>
//                   </th>

//                   <th className='small ' style={{ minWidth: '170px' }}>
//                     <div className='d-flex align-items-center'>
//                       <i className='fas fa-file-invoice me-2'></i>
//                       <span>{isAr ? 'القيد' : 'JE'}</span>
//                     </div>
//                   </th>

//                   <th className='small ' style={{ minWidth: '200px' }}>
//                     <div className='d-flex align-items-center'>
//                       <i className='fas fa-sign-out-alt text-danger me-2'></i>
//                       <span>{t('From')}</span>
//                     </div>
//                   </th>

//                   <th className='small ' style={{ minWidth: '200px' }}>
//                     <div className='d-flex align-items-center'>
//                       <i className='fas fa-sign-in-alt text-success me-2'></i>
//                       <span>{t('To')}</span>
//                     </div>
//                   </th>

//                   <th className='small text-end ' style={{ minWidth: '120px' }}>
//                     <div className='d-flex align-items-center justify-content-end'>
//                       <i className='fas fa-arrow-up text-success me-2'></i>
//                       <span>{t('Debit')}</span>
//                     </div>
//                   </th>

//                   <th className='small text-end ' style={{ minWidth: '120px' }}>
//                     <div className='d-flex align-items-center justify-content-end'>
//                       <i className='fas fa-arrow-down text-danger me-2'></i>
//                       <span>{t('Credit')}</span>
//                     </div>
//                   </th>

//                   <th className='small text-end ' style={{ minWidth: '120px' }}>
//                     <div className='d-flex align-items-center justify-content-end'>
//                       <i className='fas fa-calculator text-primary me-2'></i>
//                       <span>{isAr ? 'المبلغ' : 'Amount'}</span>
//                     </div>
//                   </th>

//                   <th className='small ' style={{ minWidth: '280px' }}>
//                     <div className='d-flex align-items-center'>
//                       <i className='fas fa-info-circle me-2'></i>
//                       <span>{t('Description')}</span>
//                     </div>
//                   </th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {!loading && items.length > 0 ? (
//                   items.map((r, idx) => {
//                     const fromId = r.froM_BRANCH || '';
//                     const toId = r.tO_BRANCH || '';
//                     const isInternalTransfer = fromId && toId ? fromId === toId : false;

//                     const dr = debitOf(r);
//                     const cr = creditOf(r);
//                     const amt = amountOf(r);

//                     return (
//                       <tr key={`${r.jE_HEADER_ID || r.code || idx}-${idx}`} className='align-middle'>
//                         <td>
//                           {/* <div className='fw-medium'>{formatDate(r.gL_DATE)}</div> */}
//                           <div className='fw-medium'>{r.gL_DATE?.split('T')[0]}</div>
//                         </td>

//                         <td>
//                           <div className='d-flex flex-column'>
//                             <span className='fw-medium'>{safe(r.code)}</span>
//                             {/* <div className='mt-1'>{getMethodBadge(r.method, isAr)}</div> */}
//                           </div>
//                         </td>

//                         <td>
//                           <div className='d-flex align-items-center'>
//                             <div
//                               className={`rounded-circle p-1 me-2 ${isInternalTransfer ? 'bg-warning' : 'bg-danger'} bg-opacity-10`}
//                             >
//                               <i
//                                 className={`fas fa-${isInternalTransfer ? 'exchange-alt' : 'sign-out-alt'} text-${isInternalTransfer ? 'warning' : 'danger'}`}
//                               ></i>
//                             </div>
//                             <div>
//                               <div className='fw-bold'>{safe(r.froM_BRANCH_NAME || r.froM_BRANCH_NAME2)}</div>
//                             </div>
//                           </div>
//                         </td>

//                         <td>
//                           <div className='d-flex align-items-center'>
//                             <div
//                               className={`rounded-circle p-1 me-2 ${isInternalTransfer ? 'bg-warning' : 'bg-success'} bg-opacity-10`}
//                             >
//                               <i
//                                 className={`fas fa-${isInternalTransfer ? 'exchange-alt' : 'sign-in-alt'} text-${isInternalTransfer ? 'warning' : 'success'}`}
//                               ></i>
//                             </div>
//                             <div>
//                               <div className='fw-bold'>{safe(r.tO_BRANCH_NAME || r.tO_BRANCH_NAME2)}</div>
//                             </div>
//                           </div>
//                         </td>

//                         <td className='text-end'>
//                           {dr > 0 ? (
//                             <div className='fw-bold text-success'>{formatNumber(dr)}</div>
//                           ) : (
//                             <div className='text-muted'>—</div>
//                           )}
//                         </td>

//                         <td className='text-end'>
//                           {cr > 0 ? (
//                             <div className='fw-bold text-danger'>{formatNumber(cr)}</div>
//                           ) : (
//                             <div className='text-muted'>—</div>
//                           )}
//                         </td>

//                         <td className='text-end'>
//                           <div className='fw-bold'>{formatNumber(amt)}</div>
//                         </td>

//                         <td>
//                           <div className='d-flex align-items-center'>
//                             <i className='fas fa-comment-alt text-muted me-2'></i>
//                             <span className={r.description ? '' : 'text-muted fst-italic'}>
//                               {safe(r.description, isAr ? 'لا يوجد وصف' : 'No description')}
//                             </span>
//                           </div>
//                         </td>
//                       </tr>
//                     );
//                   })
//                 ) : !loading ? (
//                   <tr>
//                     <td colSpan={8} className='text-center py-5'>
//                       <div className='text-muted'>
//                         <i className='fas fa-exchange-alt fa-3x mb-3 opacity-50'></i>
//                         <h6>{t('NoData')}</h6>
//                         <small>{t('TryChangingFilters')}</small>
//                       </div>
//                     </td>
//                   </tr>
//                 ) : null}
//               </tbody>

//               {!loading && items.length > 0 && (
//                 <>
//                   <tfoot className='fw-bold'>
//                     <tr className='bg-light'>
//                       <td colSpan={4} className='text-end'>
//                         <span className='h6'>{t('Total')}:</span>
//                       </td>
//                       <td className='text-end text-success'>
//                         <span className='h6'>{formatNumber(totals.totalDebit)}</span>
//                       </td>
//                       <td className='text-end text-danger'>
//                         <span className='h6'>{formatNumber(totals.totalCredit)}</span>
//                       </td>
//                       <td className='text-end'>
//                         <span className='h6'>{formatNumber(totals.totalAmount)}</span>
//                       </td>
//                       <td></td>
//                     </tr>
//                   </tfoot>

//                   {(totals.totalOutgoing > 0 || totals.totalIncoming > 0) && (
//                     <tfoot className='text-muted'>
//                       <tr>
//                         <td colSpan={7} className='text-end small'>
//                           <div className='d-flex justify-content-end gap-4 flex-wrap'>
//                             <span>
//                               <i className='fas fa-arrow-up text-success me-1'></i>
//                               {isAr ? 'صادر' : 'Outgoing'}: {formatNumber(totals.totalOutgoing)}
//                             </span>
//                             <span>
//                               <i className='fas fa-arrow-down text-danger me-1'></i>
//                               {isAr ? 'وارد' : 'Incoming'}: {formatNumber(totals.totalIncoming)}
//                             </span>
//                             <span>
//                               <i className='fas fa-bolt text-primary me-1'></i>
//                               {isAr ? 'صريح' : 'EXPLICIT'}: {formatNumber(totals.totalExplicit)}
//                             </span>
//                             <span>
//                               <i className='fas fa-magic text-info me-1'></i>
//                               {isAr ? 'مستنتج' : 'INFERRED'}: {formatNumber(totals.totalInferred)}
//                             </span>
//                           </div>
//                         </td>
//                         <td></td>
//                       </tr>
//                     </tfoot>
//                   )}
//                 </>
//               )}
//             </table>
//           </div>
//         </Loading>

//         <CardFooter>
//           <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
//             <ReportPagination reportKey={REPORT_KEY} maxVisiblePages={3} showItemsPerPage={true} />

//             {!loading && items.length > 0 && (
//               <div className='text-muted small'>
//                 <i className='fas fa-info-circle me-1'></i>
//                 {isAr ? 'عرض' : 'Showing'} {items.length} {isAr ? 'من' : 'of'} {meta?.totalRows || 0}{' '}
//                 {isAr ? 'حركة' : 'movements'}
//               </div>
//             )}
//           </div>
//         </CardFooter>
//       </Card>

//       <ReportExportExcelModal
//         show={showExport}
//         onHide={() => setShowExport(false)}
//         reportKey={REPORT_KEY}
//         endpoint={ENDPOINT}
//         columns={exportColumns}
//         exportPageSize={4000}
//         sheetName={({ isAr }) => (isAr ? 'تحويلات الفروع' : 'Branch Transfers')}
//         fileName={({ reportKey }) => `${reportKey}_${new Date().toISOString().slice(0, 10)}.xlsx`}
//       />

//       {/* <ReportSearchFiltersModal<BranchTransferInnerRequestDto>
//         show={showFilters}
//         onHide={() => setShowFilters(false)}
//         value={((report as any)?.request?.request ?? {}) as Partial<BranchTransferInnerRequestDto>}
//         fields={advancedFields}
//         title={{ ar: 'فلاتر البحث المتقدمة', en: 'Advanced Search Filters' }}
//         onApply={patch => {
//           const prevOuter = (((report as any)?.request ?? {}) as ReportRequestDto) || { request: {} as any };
//           const prevInner = (prevOuter?.request ?? {}) as BranchTransferInnerRequestDto;

//           const nextInner = cleanNulls({
//             ...prevInner,
//             ...patch,
//             pageIndex: 0
//           }) as BranchTransferInnerRequestDto;

//           const nextOuter: ReportRequestDto = {
//             ...prevOuter,
//             request: nextInner
//           };

//           dispatch(setReportRequest({ reportKey: REPORT_KEY, request: nextOuter as any }));
//           dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
//         }}
//       /> */}
//     </>
//   );
// };

// export default BranchTransfers_Paged;


import Select from 'react-select';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Loading from '@components/Shared/Loader/Loading';
import { Card, CardFooter, CardHeader } from '@components/card/card';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { initReport, getReportPagedData, selectReport, setReportRequest } from '@store/DynamicSlice/reportTableSlice';
import ReportExportExcelModal, { type ExportColumn } from '@Helper/ReportPaged/ReportExportExcelModal';
import ReportPagination from '@Helper/ReportPaged/ReportPagination';
import useGlChartLookups from '@hooks/Finance/ChartAccountsDetails/useGlChartLookups';

/** =========================
 *  INNER REQUEST SHAPE (state.request SHOULD BE THIS ONLY)
 *  Server body will be: { request: state.request }
 *  ========================= */
type BranchTransferInnerRequestDto = {
  pageIndex?: number;
  pageSize?: number;

  // Dates (dual naming)
  froM_DATE?: string | null;
  tO_DATE?: string | null;
  fromDate?: string | null;
  toDate?: string | null;

  // Branches (dual naming)
  froM_BRANCH?: string | null;
  tO_BRANCH?: string | null;
  fromBranch?: string | null;
  toBranch?: string | null;

  // Doc (dual naming)
  doC_ID?: string | null;
  docId?: string | null;

  // Optional
};

/** =========================
 *  RESPONSE SHAPE (Array items)
 *  ========================= */
type RowDto = {
  gL_DATE: string;
  code: string;

  jE_SOURCE?: string | null;
  jE_CATEGORY?: string | null;

  description?: string | null;

  doC_ID?: string | null;

  froM_BRANCH?: string | null;
  froM_BRANCH_NAME?: string | null;
  froM_BRANCH_NAME2?: string | null;

  tO_BRANCH?: string | null;
  tO_BRANCH_NAME?: string | null;
  tO_BRANCH_NAME2?: string | null;

  amount?: number | null;

  alloC_PCT?: number | null;
  tO_NET_DEBIT?: number | null;
  froM_CREDIT_ABS?: number | null;
  totaL_CREDIT_ABS?: number | null;

  jE_HEADER_ID?: string | null;
  method?: string | null; // EXPLICIT | INFERRED
};

const REPORT_KEY = 'RPT_BranchTransfers';
const ENDPOINT = 'Finance/GetBranchTransferPaged';

const safe = (v: any, fallback = '—') => (v === null || v === undefined || v === '' ? fallback : String(v));
const n0 = (v: any) => (v === null || v === undefined || Number.isNaN(Number(v)) ? 0 : Number(v));

const formatNumber = (num: number, digits: number = 2) => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  }).format(num);
};

const formatDate = (dateString: string) => {
  if (!dateString) return '—';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).format(date);
};

const getOptId = (opt: any): string | null => {
  const v = opt?.value ?? opt?.id ?? opt?.ID ?? opt?.key ?? null;
  return v ? String(v) : null;
};

/** ✅ updated: supports string YYYY-MM-DD and Date */
const isoOrNull = (d: any) => {
  if (!d) return null;
  if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d)) return `${d}T00:00:00.000Z`;
  if (d instanceof Date) return d.toISOString();
  return null;
};

const cleanNulls = <T extends Record<string, any>>(obj: T): Partial<T> => {
  const out: any = {};
  for (const [k, v] of Object.entries(obj)) {
    if (v === null || v === undefined || v === '') continue;
    out[k] = v;
  }
  return out;
};

// Heuristic for EXPLICIT rows (when debit/credit fields are null)
const guessDirection = (r: RowDto) => {
  const d = (r.description || '').toString();
  const isReceipt = /استلام|receipt/i.test(d);
  const isIssue = /صرف|issue/i.test(d);
  if (isReceipt && !isIssue) return 'IN';
  if (isIssue && !isReceipt) return 'OUT';
  return null;
};

const amountOf = (r: RowDto) => n0(r.amount);

const debitOf = (r: RowDto) => {
  if (r.tO_NET_DEBIT !== null && r.tO_NET_DEBIT !== undefined) return n0(r.tO_NET_DEBIT);
  const dir = guessDirection(r);
  if (dir === 'IN') return amountOf(r);
  return 0;
};

const creditOf = (r: RowDto) => {
  if (r.froM_CREDIT_ABS !== null && r.froM_CREDIT_ABS !== undefined) return n0(r.froM_CREDIT_ABS);
  if (r.totaL_CREDIT_ABS !== null && r.totaL_CREDIT_ABS !== undefined) return n0(r.totaL_CREDIT_ABS);
  const dir = guessDirection(r);
  if (dir === 'OUT') return amountOf(r);
  return 0;
};

const BranchTransfers_Paged = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  // options
  const { OptionsBranches, loading: loading2 } = useGlChartLookups();

  // Filters state
  const [branchFromFilter, setBranchFromFilter] = useState<any>(null);
  const [branchToFilter, setBranchToFilter] = useState<any>(null);

  // Date range (HTML input gives string YYYY-MM-DD)
  const [fromDate, setFromDate] = useState<any>(null);
  const [toDate, setToDate] = useState<any>(null);

  const [showExport, setShowExport] = useState(false);

  // report state
  const report = useAppSelector(s => selectReport(s as any, REPORT_KEY));
  const items = (report?.items ?? []) as RowDto[];
  const meta = report?.meta ?? null;
  const loading = report?.loading ?? false;
  const error = report?.error ?? null;
  const isAr = i18n.language !== 'en';

  const activeFiltersCount = useMemo(() => {
    let c = 0;
    if (branchFromFilter) c++;
    if (branchToFilter) c++;
    if (fromDate) c++;
    if (toDate) c++;
    return c;
  }, [branchFromFilter, branchToFilter, fromDate, toDate]);

  const exportColumns: ExportColumn<RowDto>[] = [
    { headerAr: 'تاريخ القيد', headerEn: 'GL Date', value: r => formatDate(r.gL_DATE) },
    { headerAr: 'رقم القيد', headerEn: 'JE Code', value: r => r.code || '' },
    { headerAr: 'من فرع', headerEn: 'From Branch', value: r => r.froM_BRANCH_NAME || '' },
    { headerAr: 'إلى فرع', headerEn: 'To Branch', value: r => r.tO_BRANCH_NAME || '' },
    { headerAr: 'مدين', headerEn: 'Debit', value: r => debitOf(r) },
    { headerAr: 'دائن', headerEn: 'Credit', value: r => creditOf(r) },
    { headerAr: 'المبلغ', headerEn: 'Amount', value: r => amountOf(r) },
    { headerAr: 'الطريقة', headerEn: 'Method', value: r => r.method || '' },
    { headerAr: 'الوصف', headerEn: 'Description', value: r => r.description || '' },
    { headerAr: 'معرف المستند', headerEn: 'Doc ID', value: r => r.doC_ID || '' }
  ];

  useEffect(() => {
    const initialRequest: BranchTransferInnerRequestDto = {
      pageIndex: 0,
      pageSize: 50
    };

    dispatch(
      initReport({
        reportKey: REPORT_KEY,
        endpoint: ENDPOINT,
        initialRequest
      })
    );

    dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
  }, [dispatch]);

  /** ✅ fixed: no outer wrapper, keep ONLY inner request in state */
  const applyFilters = () => {
    const fromBranchId = getOptId(branchFromFilter);
    const toBranchId = getOptId(branchToFilter);

    const prevReq = (((report as any)?.request ?? {}) as BranchTransferInnerRequestDto) || {};

    const nextReq: BranchTransferInnerRequestDto = {
      ...prevReq,
      pageIndex: 0,
      pageSize: prevReq.pageSize ?? 50,

      // Dates (dual naming)
      froM_DATE: isoOrNull(fromDate),
      tO_DATE: isoOrNull(toDate),
      fromDate: isoOrNull(fromDate),
      toDate: isoOrNull(toDate),

      // Branches (dual naming)
      froM_BRANCH: fromBranchId,
      tO_BRANCH: toBranchId

      // (you intentionally commented these)
      // fromBranch: fromBranchId,
      // toBranch: toBranchId
    };

    dispatch(setReportRequest({ reportKey: REPORT_KEY, request: cleanNulls(nextReq) as any }));
    dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
  };

  /** ✅ fixed: reset to inner request only */
  const clearFilters = () => {
    setBranchFromFilter(null);
    setBranchToFilter(null);
    setFromDate(null);
    setToDate(null);

    const resetReq: BranchTransferInnerRequestDto = {
      pageIndex: 0,
      pageSize: 50
    };

    dispatch(setReportRequest({ reportKey: REPORT_KEY, request: resetReq as any }));
    dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
  };

  // Totals
  const totals = useMemo(() => {
    return items.reduce(
      (acc, row) => {
        const a = amountOf(row);
        const dr = debitOf(row);
        const cr = creditOf(row);

        acc.totalAmount += a;
        acc.totalDebit += dr;
        acc.totalCredit += cr;

        // Outgoing/Incoming (based on DR/CR heuristics)
        const fromId = row.froM_BRANCH || '';
        const toId = row.tO_BRANCH || '';
        if (fromId && toId && fromId !== toId) {
          if (cr > 0) acc.totalOutgoing += cr;
          if (dr > 0) acc.totalIncoming += dr;
        }

        if ((row.method || '').toUpperCase() === 'EXPLICIT') acc.totalExplicit += a;
        if ((row.method || '').toUpperCase() === 'INFERRED') acc.totalInferred += a;

        return acc;
      },
      {
        totalAmount: 0,
        totalDebit: 0,
        totalCredit: 0,
        totalOutgoing: 0,
        totalIncoming: 0,
        totalExplicit: 0,
        totalInferred: 0
      }
    );
  }, [items]);

  return (
    <>
      <CardHeader className='mb-3'>
        <div className='row g-2 align-items-center'>
          {/* من فرع */}
          <div className='col-lg-3'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-sign-out-alt text-danger'></i>
              </span>
              <Select
                isLoading={loading2}
                value={branchFromFilter}
                onChange={setBranchFromFilter}
                options={OptionsBranches}
                placeholder={isAr ? 'من فرع' : 'From Branch'}
                isClearable
                isSearchable
                className='flex-grow-1'
                classNamePrefix='react-select'
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </div>

          {/* إلى فرع */}
          <div className='col-lg-3'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-sign-in-alt text-success'></i>
              </span>
              <Select
                isLoading={loading2}
                value={branchToFilter}
                onChange={setBranchToFilter}
                options={OptionsBranches}
                placeholder={isAr ? 'إلى فرع' : 'To Branch'}
                isClearable
                isSearchable
                className='flex-grow-1'
                classNamePrefix='react-select'
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </div>

          {/* من تاريخ */}
          <div className='col-lg-2'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-calendar'></i>
              </span>
              <input
                type='date'
                className='form-control'
                value={fromDate || ''}
                onChange={e => setFromDate(e.target.value)}
                placeholder={isAr ? 'من تاريخ' : 'From Date'}
              />
            </div>
          </div>

          {/* إلى تاريخ */}
          <div className='col-lg-2'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-calendar'></i>
              </span>
              <input
                type='date'
                className='form-control'
                value={toDate || ''}
                onChange={e => setToDate(e.target.value)}
                min={fromDate || undefined}
                placeholder={isAr ? 'إلى تاريخ' : 'To Date'}
              />
            </div>
          </div>

          {/* Buttons */}
          <div className='col-lg-2 text-end'>
            <button
              className='btn btn-outline-secondary me-2'
              type='button'
              onClick={clearFilters}
              title={t('ClearFilters')}
              disabled={activeFiltersCount === 0}
            >
              <i className='fas fa-times fa-fw'></i>
            </button>
            <button
              className='btn btn-theme me-2'
              type='button'
              onClick={applyFilters}
              title={t('ApplyFilters')}
              disabled={activeFiltersCount === 0}
            >
              <i className='fas fa-filter fa-fw'></i>
            </button>

            <button
              className='btn btn-outline-success'
              type='button'
              onClick={() => setShowExport(true)}
              title={t('Export')}
              disabled={loading}
            >
              <i className='fas fa-file-excel fa-fw'></i>
            </button>
          </div>
        </div>
      </CardHeader>

      <Card className='mb-4'>
        <Loading loading={loading} error={error}>
          <div className='table-responsive' style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
            <table className='table table-hover mb-0'>
              <thead className='sticky-top' style={{ top: 0, zIndex: 10 }}>
                <tr className='bg-theme bg-opacity-35' style={{ backdropFilter: 'blur(20px)' }}>
                  <th className='small ' style={{ minWidth: '110px' }}>
                    <div className='d-flex align-items-center'>
                       <span>{t('Date')}</span>
                    </div>
                  </th>

                  <th className='small ' style={{ minWidth: '170px' }}>
                    <div className='d-flex align-items-center'>
                       <span>{isAr ? 'القيد' : 'JE'}</span>
                    </div>
                  </th>

                  <th className='small ' style={{ minWidth: '200px' }}>
                    <div className='d-flex align-items-center'>
                       <span>{t('From')}</span>
                    </div>
                  </th>

                  <th className='small ' style={{ minWidth: '200px' }}>
                    <div className='d-flex align-items-center'>
                       <span>{t('To')}</span>
                    </div>
                  </th>

                  {/* <th className='small text-end ' style={{ minWidth: '120px' }}>
                    <div className='d-flex align-items-center justify-content-end'>
                       <span>{t('Debit')}</span>
                    </div>
                  </th>

                  <th className='small text-end ' style={{ minWidth: '120px' }}>
                    <div className='d-flex align-items-center justify-content-end'>
                       <span>{t('Credit')}</span>
                    </div>
                  </th> */}

                  <th className='small text-end ' style={{ minWidth: '120px' }}>
                    <div className='d-flex align-items-center justify-content-end'>
                       <span>{isAr ? 'المبلغ' : 'Amount'}</span>
                    </div>
                  </th>

                  <th className='small ' style={{ minWidth: '280px' }}>
                    <div className='d-flex align-items-center'>
                       <span>{t('Description')}</span>
                    </div>
                  </th>
                </tr>
              </thead>

              <tbody>
                {!loading && items.length > 0 ? (
                  items.map((r, idx) => {
                    const fromId = r.froM_BRANCH || '';
                    const toId = r.tO_BRANCH || '';
                    const isInternalTransfer = fromId && toId ? fromId === toId : false;

                    const dr = debitOf(r);
                    const cr = creditOf(r);
                    const amt = amountOf(r);

                    return (
                      <tr key={`${r.jE_HEADER_ID || r.code || idx}-${idx}`} className='align-middle'>
                        <td>
                          <div className='fw-medium'>{r.gL_DATE?.split('T')[0]}</div>
                        </td>

                        <td>
                          <div className='d-flex flex-column'>
                            <span className='fw-medium'>{safe(r.code)}</span>
                          </div>
                        </td>

                        <td>
                          <div className='d-flex align-items-center'>
                            <div className={` p-1 me-2 `}>
                              <i className={`fas fa-${isInternalTransfer ? 'exchange-alt' : 'sign-out-alt'} text-${isInternalTransfer ? 'warning' : 'danger'}`}></i>
                            </div>
                            <div>
                              <div className='fw-bold'>{safe(r.froM_BRANCH_NAME || r.froM_BRANCH_NAME2)}</div>
                            </div>
                          </div>
                        </td>

                        <td>
                          <div className='d-flex align-items-center'>
                            <div className={`rounded-circle p-1 me-2 `}>
                              <i className={`fas fa-${isInternalTransfer ? 'exchange-alt' : 'sign-in-alt'} text-${isInternalTransfer ? 'warning' : 'success'}`}></i>
                            </div>
                            <div>
                              <div className='fw-bold'>{safe(r.tO_BRANCH_NAME || r.tO_BRANCH_NAME2)}</div>
                            </div>
                          </div>
                        </td>

                        {/* <td className='text-end'>
                          {dr > 0 ? <div className='fw-bold text-success'>{formatNumber(dr)}</div> : <div className='text-muted'>—</div>}
                        </td>

                        <td className='text-end'>
                          {cr > 0 ? <div className='fw-bold text-danger'>{formatNumber(cr)}</div> : <div className='text-muted'>—</div>}
                        </td> */}

                        <td className='text-end'>
                          <div className='fw-bold'>{formatNumber(amt)}</div>
                        </td>

                        <td>
                          <div className='d-flex align-items-center'>
                            {/* <i className='fas fa-comment-alt text-muted me-2'></i> */}
                            <span className={r.description ? '' : 'text-muted fst-italic'}>
                              {safe(r.description, isAr ? 'لا يوجد وصف' : 'No description')}
                            </span>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : !loading ? (
                  <tr>
                    <td colSpan={8} className='text-center py-5'>
                      <div className='text-muted'>
                        <i className='fas fa-exchange-alt fa-3x mb-3 opacity-50'></i>
                        <h6>{t('NoData')}</h6>
                        <small>{t('TryChangingFilters')}</small>
                      </div>
                    </td>
                  </tr>
                ) : null}
              </tbody>

              {/* {!loading && items.length > 0 && (
                <>
                  <tfoot className='fw-bold'>
                    <tr className='bg-light'>
                      <td colSpan={4} className='text-end'>
                        <span className='h6'>{t('Total')}:</span>
                      </td>
                      <td className='text-end text-success'>
                        <span className='h6'>{formatNumber(totals.totalDebit)}</span>
                      </td>
                      <td className='text-end text-danger'>
                        <span className='h6'>{formatNumber(totals.totalCredit)}</span>
                      </td>
                      <td className='text-end'>
                        <span className='h6'>{formatNumber(totals.totalAmount)}</span>
                      </td>
                      <td></td>
                    </tr>
                  </tfoot>

                
                </>
              )} */}
            </table>
          </div>
        </Loading>

        <CardFooter>
          <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
            <ReportPagination reportKey={REPORT_KEY} maxVisiblePages={3} showItemsPerPage={true} />

            {!loading && items.length > 0 && (
              <div className='text-muted small'>
                <i className='fas fa-info-circle me-1'></i>
                {isAr ? 'عرض' : 'Showing'} {items.length} {isAr ? 'من' : 'of'} {meta?.totalRows || 0}{' '}
                {isAr ? 'حركة' : 'movements'}
              </div>
            )}
          </div>
        </CardFooter>
      </Card>

      <ReportExportExcelModal
        show={showExport}
        onHide={() => setShowExport(false)}
        reportKey={REPORT_KEY}
        endpoint={ENDPOINT}
        columns={exportColumns}
        exportPageSize={4000}
        sheetName={({ isAr }) => (isAr ? 'تحويلات الفروع' : 'Branch Transfers')}
        fileName={({ reportKey }) => `${reportKey}_${new Date().toISOString().slice(0, 10)}.xlsx`}
      />
    </>
  );
};

export default BranchTransfers_Paged;
